import React from "react";
import { Alert as AlertAntd } from "antd";

interface propsInterface {
  message?: string | null;
  onClose?: Function;
  type?: "error" | "success" | "info" | "warning" | undefined;
  className?: string;
}

const AlertBlock = ({ message, onClose, type, className }: propsInterface ) => {
  if(!message) {
    return null;
  }

  return (
    <AlertAntd
      className={`v-alert-block ${className ? className : ''}`}
      onClose={() => onClose && onClose()}
      message={message}
      type={type}
      showIcon
      closable
    />
  )
}

export default AlertBlock;